let instance;

let debug = false;
export function debugAmplitude(value) {
  debug = value;
}

let initPromise;
export async function initAmplitude(config) {
  if (!initPromise) {
    initPromise = import("@amplitude/analytics-browser").then((mod) => {
      instance = mod;
      instance.init(config.apiKey, {
        autocapture: false,
        // Skip remote config fetch — we don't use autocapture or Session Replay, so it blocks on CSP for no benefit.
        fetchRemoteConfig: false,
        serverZone: "EU",
        serverUrl: config.reverseProxy || undefined,
        trackingOptions: { ipAddress: false },
      });
    });
  }
  return initPromise;
}

export function identifyAmplitudeUser(license, user) {
  if (!instance) return;

  instance.setUserId(user.id);

  setAmplitudeUserProperties([
    ["company", user.company],
    ["role", user.role],
    ["type", license.type],
    ["isLicenseExpired", license.expiryDate <= new Date()],
    ["plan", license.plan],
    ["language", user.preferredLanguage],
  ]);
}

/**
 * Set any custom amplitude user property.
 * The new value applies to all future events.
 */
function setAmplitudeUserProperties(entries) {
  if (!instance) return;

  const identifyEvent = new instance.Identify();
  for (const [property, value] of entries) {
    identifyEvent.set(property, value);
  }
  instance.identify(identifyEvent);
}

export function setAmplitudeOptOut(optOut) {
  instance?.setOptOut(optOut);
}

export function trackAmplitude(event, data) {
  if (debug) {
    // eslint-disable-next-line no-console
    console.info("trackEvent", event, data);
  }
  instance?.track(event, data);
}
